import { Reducer } from "redux";
import {
    SET_USER,
    CLEAR_USER,
    AuthentificationActionType,
    UserData,
} from "../actions/authentificationActions";

const savedState: UserData | null =
    sessionStorage.getItem("user") !== null
        ? JSON.parse(sessionStorage.getItem("user") || "")
        : null;

const initialState: UserData = {
    guid: undefined,
    username: undefined,
    firstName: undefined,
    lastName: undefined,
    token: undefined,
    role: undefined,
    tso: undefined,
};

export const userReducer: Reducer<UserData> = (
    state: UserData = savedState || initialState,
    action: AuthentificationActionType
): UserData => {
    switch (action.type) {
        case SET_USER:
            return { ...action.user };
        case CLEAR_USER:
            return { ...initialState };
        default:
            return state;
    }
};
